import type { AppContext } from "@/types/scheduling";
import type { WritableDraft } from "immer";

import { produce } from "immer";

export const handleSaveStepName = <T extends AppContext>(context: T, params: { key: string }) => {
  return produce(context, (draft: WritableDraft<AppContext>) => {
    draft.step = params.key;
  })
}
